import {EditOutlined} from '@ant-design/icons';
import {Form} from 'antd';
import {FormInstance} from 'antd/es/form';
import cn from 'classnames';
import React from 'react';

import {RichTextEditor} from 'components/rich-text';

import './comments-form-content.less';

import {IDocumentStatusChangeForm} from '../../document-status-change-modal.types';
import {sanitizeCommentValue} from '../../document-status-change-modal.utils';

interface IDocumentCommentRowProps {
    id: string;
    docName?: string;
    isActive: boolean;
    form: FormInstance<IDocumentStatusChangeForm>;
    handleToggleComment: (id: string) => void;
}

export const DocumentCommentRow = ({
    id,
    docName,
    isActive,
    form,
    handleToggleComment,
}: IDocumentCommentRowProps) => {
    const commentValue = form.getFieldValue(`uniqueComment-${id}`);
    const isEmptyValue = !sanitizeCommentValue(commentValue);

    return (
        <>
            <div className="comments-form-content__document-row">
                <div className="comments-form-content__document-title">
                    {docName || ''}
                </div>
                <div className="comments-form-content__icon-wrapper">
                    <div className="comments-form-content__divider" />
                    <EditOutlined
                        onClick={() => handleToggleComment(id)}
                        className={cn(
                            'comments-form-content__edit-icon',
                            {
                                'comments-form-content__edit-icon--active': isActive || !isEmptyValue,
                            },
                        )}
                    />
                </div>
            </div>

            <Form.Item
                name={`uniqueComment-${id}`}
                label="Оставить комментарий"
                className={cn(
                    'comments-form-content__comment-field',
                    {'comments-form-content__comment-field--hidden': !isActive},
                )}
            >
                <RichTextEditor
                    key={`comment-${id}`}
                    placeholder="Введите комментарий"
                    toolbarId={`comment-${id}`}
                />
            </Form.Item>
        </>
    );
};
